import ToasterNotification from './toaster-notification.component';

export default ToasterNotification;
